module.exports = __webpack_public_path__ + "img/12.4d804f2a.png";